import { ActionKeys } from './constants';

export function loginFetchCSRF() {
  return <const>{
    type: ActionKeys.LOGIN_FETCH_CSRF,
  };
}

export function loginFetchCSRFSuccess(csrfToken: string) {
  return <const>{
    type: ActionKeys.LOGIN_FETCH_CSRF_SUCCESS,
    payload: {
      csrfToken,
    },
  };
}

export function loginFetchCSRFError(error: string) {
  return <const>{
    type: ActionKeys.LOGIN_FETCH_CSRF_ERROR,
    payload: {
      error,
    },
  };
}

export function loginStart(
  email: string,
  password: string,
  gRecaptchaResponse: string | null,
  next?: string,
) {
  return <const>{
    type: ActionKeys.LOGIN_SUBMIT,
    payload: {
      email,
      next,
      gRecaptchaResponse,
      password,
    },
  };
}

export function loginSuccess(next?: string) {
  return <const>{
    type: ActionKeys.LOGIN_SUCCESS,
    payload: { next },
  };
}

export function loginError(error) {
  return <const>{
    type: ActionKeys.LOGIN_ERROR,
    payload: { error },
  };
}

export function resetPasswordSubmit(email: string, gRecaptchaResponse: string | null) {
  return <const>{
    type: ActionKeys.RESET_PASSWORD_SUBMIT,
    payload: {
      email,
      gRecaptchaResponse,
    },
  };
}

export function resetPasswordSuccess() {
  return <const>{
    type: ActionKeys.RESET_PASSWORD_SUCCESS,
  };
}

export function resetPasswordError(error: string) {
  return <const>{
    type: ActionKeys.RESET_PASSWORD_ERROR,
    payload: {
      error,
    },
  };
}

export function verify2FASubmit(
  email: string,
  password: string,
  challengeCode: string,
  gRecaptchaResponse: string | null,
  next?: string,
) {
  return <const>{
    type: ActionKeys.VERIFY_2FA_SUBMIT,
    payload: {
      email,
      next,
      password,
      challengeCode,
      gRecaptchaResponse,
    },
  };
}

export function verify2FASuccess() {
  return <const>{
    type: ActionKeys.VERIFY_2FA_SUCCESS,
  };
}

export function verify2FAError(error: string) {
  return <const>{
    type: ActionKeys.VERIFY_2FA_ERROR,
    payload: {
      error,
    },
  };
}

export function verify2FAStart() {
  return <const>{
    type: ActionKeys.VERIFY_2FA_START,
  };
}

export function resend2FAEmail(email: string) {
  return <const>{
    type: ActionKeys.RESEND_2FA_SUBMIT,
    payload: {
      email,
    },
  };
}

export function resend2FASuccess(successMessage: string) {
  return <const>{
    type: ActionKeys.RESEND_2FA_SUCCESS,
    payload: {
      successMessage,
    },
  };
}

export function resend2FAError(error: string) {
  return <const>{
    type: ActionKeys.RESEND_2FA_ERROR,
    payload: {
      error: error,
    },
  };
}

export type LoginActions =
  | ReturnType<typeof resetPasswordSubmit>
  | ReturnType<typeof resetPasswordSuccess>
  | ReturnType<typeof resetPasswordError>
  | ReturnType<typeof loginFetchCSRF>
  | ReturnType<typeof loginFetchCSRFSuccess>
  | ReturnType<typeof loginFetchCSRFError>
  | ReturnType<typeof loginStart>
  | ReturnType<typeof loginSuccess>
  | ReturnType<typeof loginError>
  | ReturnType<typeof verify2FAStart>
  | ReturnType<typeof verify2FASubmit>
  | ReturnType<typeof verify2FASuccess>
  | ReturnType<typeof verify2FAError>
  | ReturnType<typeof resend2FAEmail>
  | ReturnType<typeof resend2FASuccess>
  | ReturnType<typeof resend2FAError>;
